<template>
    <ValidationObserver ref="form">
        <div class="form">

            <QualificationsForm
                @data-changed="updateForm"
                :user="user"
                :languages-list="languagesList"
            ></QualificationsForm>

            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-6"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <a href="javascript:void(0)" @click="validate" class="btn btn--secondary w-100 w-sm-auto">Continue</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import QualificationsForm from "../CommonForms/QualificationsForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    name: 'ApplicantFormStep7',
    components: {QualificationsForm},
    props: {
        languagesList: {
            type: Array,
            required: true
        },
        user: {
            type: Object
        }
    },
    data() {
        return {
            dataFormStep7: this.user.qualification ?? {}
        }
    },
    methods: {
        async validate() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            } else {
                await this.save()
            }
        },
        async save() {

                try {
                    const response = await ApplicationFormService.saveStep7(this.dataFormStep7);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.href = '/application-step-8';
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
        },
        updateForm(dataQualificationsForm) {
            this.dataFormStep7 = dataQualificationsForm;
        }

    },

}

</script>

<style scoped>

</style>
